import React, { createContext } from "react";
export const TranslatorContext = createContext({
    locale: "en",
});
/**
 * Wrap the application in a TranslatorProvider to use useTranslate in app
 * components. The app must provide the translations for the selected language.
 */
export default function TranslatorProvider({ translations, children, }) {
    return (React.createElement(TranslatorContext.Provider, { value: translations }, children));
}
